<div style="padding-top:4px;">

    <span>
        {{dlg_data.title}}
    </span>
    <p class="dlg-box-bdy">
        {{dlg_data.body}}
    </p>
    <div>
        <button  style="    border: 1px solid;
        padding: 4px;
        float: right;
        border-radius: 7px;
        padding-left: 14px;
        padding-right: 14px;
        margin-top: 5px;" (click)="clsDlgBx()">Dismiss</button>
    </div>
</div>